import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Pagination, Table, Loader, Dimmer } from 'semantic-ui-react';
import { getGoBizLinking } from 'state/business/actions';
import { format } from 'date-fns';

const GoBizLinking = props => {
  const { goBizLinking, allBusiness, gettingGoBizLinking, dispatch } = props;

  useEffect(() => {
    const payload = {
      businessId: allBusiness.data[allBusiness.activeIndex].id,
      page: 1,
      size: 10,
    };
    dispatch(getGoBizLinking(payload));
  }, [allBusiness.activeIndex, allBusiness.data, dispatch]);

  const size = 10;
  let totalPages = 1;
  if (goBizLinking.paging)
    totalPages = Math.ceil(goBizLinking.paging.total / size);

  const handleOnPageChange = (_, val) => {
    const { activePage } = val;
    const payload = {
      businessId: allBusiness.data[allBusiness.activeIndex].id,
      page: activePage,
      size: 10,
    };
    dispatch(getGoBizLinking(payload));
  };

  const getStatusColor = status => {
    if (status === 'active') return 'green';
    if (status === 'deactive') return 'orange';
    return 'black';
  };

  const getStatusDisplay = status => {
    if (status === 'active') return 'Linked';
    if (status === 'deactive') return 'Recommended';
    return 'Unlinked';
  };

  return (
    <>
      <Dimmer active={gettingGoBizLinking}>
        <Loader size="massive">Loading</Loader>
      </Dimmer>
      <div
        style={{
          'overflow-x': 'scroll',
        }}
      >
        <Table celled>
          <Table.Header>
            <Table.Row textAlign="center">
              <Table.HeaderCell>ID</Table.HeaderCell>
              <Table.HeaderCell>Outlet Name</Table.HeaderCell>
              <Table.HeaderCell>Linked At</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>GoBiz ID</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {goBizLinking.data ? (
              goBizLinking.data.outlets.map(outlet => {
                let keys = '';
                Object.keys(outlet).forEach(key => {
                  keys += outlet[key];
                });
                return (
                  <Table.Row textAlign="center" key={`${keys}slots`}>
                    <Table.Cell key={`${keys}outletId`}>{outlet.id}</Table.Cell>
                    <Table.Cell key={`${keys}outletName`}>
                      {outlet.name}
                    </Table.Cell>
                    <Table.Cell key={`${keys}saudagarLinkedAt`}>
                      {outlet.saudagar_linked_at
                        ? format(
                            new Date(outlet.saudagar_linked_at),
                            'dd/MM/yyyy'
                          )
                        : '-'}
                    </Table.Cell>
                    <Table.Cell
                      key={`${keys}saudagarStatus`}
                      style={{
                        color: getStatusColor(outlet.saudagar_status),
                      }}
                    >
                      {getStatusDisplay(outlet.saudagar_status)}
                    </Table.Cell>
                    <Table.Cell key={`${keys}saudagarId`}>
                      {outlet.saudagar_id ? outlet.saudagar_id : '-'}
                    </Table.Cell>
                  </Table.Row>
                );
              })
            ) : (
              <></>
            )}
          </Table.Body>
          {goBizLinking.paging ? (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="7">
                  <Pagination
                    activePage={goBizLinking.paging.page}
                    totalPages={totalPages}
                    onPageChange={handleOnPageChange}
                    size="mini"
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          ) : (
            <></>
          )}
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = ({ business }) => ({
  goBizLinking: business.goBizLinking,
  allBusiness: business.allBusiness,
  gettingGoBizLinking: business.gettingGoBizLinking,
});

GoBizLinking.propTypes = {
  dispatch: PropTypes.func.isRequired,
  goBizLinking: PropTypes.object.isRequired,
  allBusiness: PropTypes.object.isRequired,
  gettingGoBizLinking: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(GoBizLinking);
